import BaseInputLabel from '@material-ui/core/InputLabel'

const InputLabel = BaseInputLabel

export default InputLabel
